import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=30b912f4&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectsPage.vue?vue&type=style&index=0&id=30b912f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b912f4",
  null
  
)

export default component.exports